
const getCategory = (updateData: any) => {
    if (updateData) {
        if (updateData.type === 'dresdengo') {
            return 'reading-glasses';
        }
        if (updateData.glassesData.category) {
            return updateData.glassesData.category;
        }
        if (updateData.glassesData.prescription && updateData.glassesData.purpose !== 'non-prescription') {
            if (
                updateData.glassesData.lensType.includes('sun') ||
                updateData.glassesData.lensType.includes('polarised') ||
                updateData.glassesData.lensType.includes('photochromic') ||
                updateData.glassesData.lensType.includes('mirror')
            ) {
                return 'prescription-sunglasses';
            } else {
                return 'prescription-glasses';
            }
        } else {
            if (
                updateData.glassesData.lensType.includes('sun') ||
                updateData.glassesData.lensType.includes('polarised') ||
                updateData.glassesData.lensType.includes('photochromic') ||
                updateData.glassesData.lensType.includes('mirror')
            ) {
                return 'non-prescription-sunglasses';
            }

            if (updateData.glassesData.lensType == 'blue-light-filter') {
                return 'blue-light-filter-glasses';
            }
        }
    }
};

export const checkUpdateData = (updateData: any, cat: string, productColor: string) => {
    if (updateData) {
        const updateCategory = getCategory(updateData);
        if (updateCategory == cat && productColor == updateData.glassesData.frameColor) {
            return true;
        }
        return false;
    }
    return false;
}

